import { SECURITY_GET_USER_REQUEST } from "UserAuthorized/actionTypes";

export const securityGetUser = () => {
  return { type: SECURITY_GET_USER_REQUEST };
};
